import * as React from 'react';
import FolderTreeType from 'mini-mail-folder-store/lib/store/schema/FolderTreeType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import handleArrowKeyPress from 'mini-accessibility/lib/utils/handleKeyArrowPress';
import TreeNode from './TreeNode';
import TreeRootNode from './TreeRootNode';
import { TreeNodeData } from '../schema/TreeNodeData';
import {
    arrowLocation,
    handleArrowKeyPressConfig,
} from 'mini-accessibility/lib/schema/handleKeyArrowPressDeclarations';

export interface TreeProps {
    rootIconName?: string;
    rootDisplayName?: string;
    isRootExpanded?: boolean;
    onRootNodeClicked?: () => void;
    nodeIds?: string[];
    getNodeData?: (nodeId: string) => TreeNodeData;
    depth?: number;
    itemRefs?: React.RefObject<any>[];
    startIndex?: number;
    totalLength?: number;
    folder1ExpandedState?: boolean;
    folder2ExpandedState?: boolean;
    setExpandedFolderState?: React.Dispatch<React.SetStateAction<boolean>>;
    folderTreeType?: FolderTreeType;
}

/**
 * Component which renders the Tree structure.
 * @param props TreeProps
 */
const Tree = (props: TreeProps) => {
    const {
        rootDisplayName,
        isRootExpanded,
        onRootNodeClicked,
        nodeIds,
        getNodeData,
        rootIconName,
        depth,
        itemRefs,
        startIndex,
        totalLength,
        folderTreeType,
    } = props;

    const keyConfigRoot: handleArrowKeyPressConfig = {
        itemIndex: startIndex,
        itemRefs: itemRefs,
        length: totalLength,
        configUp: arrowLocation.MailBody,
        folder1ExpandedState: getUserConfiguration().UserOptions.IsFavoritesFolderTreeCollapsed,
        folder2ExpandedState: getUserConfiguration().UserOptions.IsMailRootFolderTreeCollapsed,
        configDown: arrowLocation.MailBody,
        rootNode: true,
        folderTreeType: folderTreeType,
    };

    const setKeyConfigNode = index => {
        return {
            itemIndex: startIndex + index + 1,
            itemRefs: itemRefs,
            length: totalLength,
            configUp: arrowLocation.MailBody,
            folder1ExpandedState: getUserConfiguration().UserOptions.IsFavoritesFolderTreeCollapsed,
            folder2ExpandedState: getUserConfiguration().UserOptions.IsMailRootFolderTreeCollapsed,
            configDown: arrowLocation.MailBody,
            rootNode: false,
            folderTreeType: folderTreeType,
        };
    };

    return (
        <>
            {rootDisplayName && (
                <TreeRootNode
                    key={rootDisplayName}
                    rootDisplayName={rootDisplayName}
                    onRootNodeClicked={onRootNodeClicked ? onRootNodeClicked : undefined}
                    rootIconName={rootIconName ? rootIconName : undefined}
                    isRootExpanded={isRootExpanded}
                    refValue={itemRefs ? itemRefs[startIndex] : undefined}
                    onKeyDown={handleArrowKeyPress ? handleArrowKeyPress(keyConfigRoot) : undefined}
                />
            )}
            {isRootExpanded &&
                nodeIds.map((nodeId, index) => (
                    <TreeNode
                        key={nodeId}
                        nodeId={nodeId}
                        getNodeData={getNodeData ? getNodeData : undefined}
                        depth={depth || 0}
                        refValue={itemRefs ? itemRefs[index + startIndex + 1] : undefined}
                        onKeyDown={
                            handleArrowKeyPress
                                ? handleArrowKeyPress(setKeyConfigNode(index))
                                : undefined
                        }
                    />
                ))}
        </>
    );
};

export default Tree;
